import { generateVariables } from '@getmayday/vue-modules';

import { COLORS } from '../theme';

const defaultConfig = {
  primary: COLORS.blue.DEFAULT,
  secondary: COLORS.blue['3'],
};

const useColors = (
  isLoggedIn: Ref<boolean>,
  primaryColor?: Ref<string | undefined>,
  secondaryColor?: Ref<string | undefined>,
) => {
  const primary = computed(() => {
    if (!isLoggedIn.value) return defaultConfig.primary;
    return primaryColor?.value || defaultConfig.primary;
  });

  const secondary = computed(() => {
    if (!isLoggedIn.value) return defaultConfig.secondary;
    return secondaryColor?.value || defaultConfig.secondary;
  });

  const colorsStyle = computed(() => {
    const primaryColors = generateVariables('primary', primary.value);
    const secondaryColors = generateVariables('secondary', secondary.value);

    return { ...primaryColors, ...secondaryColors };
  });

  // isAlt => light primary color
  const isAlt = computed(() => {
    return colorsStyle.value['--primary-contrast'] !== '255 255 255';
  });

  return { colorsStyle, isAlt };
};

export default useColors;
